import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, Routes, useLocation, useNavigationType } from 'react-router-dom';

Sentry.init({
  dsn: 'https://ec1b18db2ea743dda15594a728d9414b@sentry.trafficon.eu/8',
  enabled: import.meta.env.MODE !== 'development',
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: import.meta.env.MODE === 'development' ? 1.0 : 0.1,
});

export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
